import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3272b7ee")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "horiz-bar" }, null, -1)
const _hoisted_2 = { class: "flex-grow" }
_popScopeId()

import { computed } from 'vue';

/**
 * TYPES
 */
type Props = {
  items: Array<any>;
  title?: string;
  hideItems?: boolean;
  size?: string;
  offsetClassOverrides?: string;
  initVertBarClassOverrides?: string;
};

/**
 * PROPS
 */

export default _defineComponent({
  props: {
    items: { type: Array, required: true },
    title: { type: String, required: false, default: 'Title' },
    hideItems: { type: Boolean, required: false, default: false },
    size: { type: String, required: false, default: 'md' },
    offsetClassOverrides: { type: String, required: false, default: '' },
    initVertBarClassOverrides: { type: String, required: false, default: '' }
  } as unknown as undefined,
  setup(__props: {
  items: Array<any>;
  title?: string;
  hideItems?: boolean;
  size?: string;
  offsetClassOverrides?: string;
  initVertBarClassOverrides?: string;
}) {

const props = __props


/**
 * COMPUTED
 */
const initVertBarSizes = computed(() => {
  if (props.initVertBarClassOverrides != null) {
    return props.initVertBarClassOverrides;
  }

  switch (props.size) {
    case 'lg':
      return 'h-8 -mt-8';
    default:
      return 'h-4 -mt-4';
  }
});

const vertBarSizes = computed(() => {
  switch (props.size) {
    case 'lg':
      return 'h-16 -mt-16';
    default:
      return 'h-8 -mt-8';
  }
});

const spacingClass = computed(() => {
  switch (props.size) {
    case 'lg':
      return 'mt-4';
    default:
      return 'mt-0';
  }
});

const offsetClass = computed(() => {
  if (props.offsetClassOverrides != null) {
    return props.offsetClassOverrides;
  }

  switch (props.size) {
    case 'lg':
      return 'mt-3 ml-px';
    default:
      return 'mt-2 ml-px';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(__props.title), 1)
      ])
    ]),
    (!__props.hideItems)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['flex flex-col', _unref(offsetClass)])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(['flex items-center', { [_unref(spacingClass)]: i !== 0 }])
            }, [
              (i === 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['init-vert-bar', _unref(initVertBarSizes)])
                  }, null, 2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(['vert-bar', _unref(vertBarSizes)])
                  }, null, 2)),
              _hoisted_1,
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "item", { item: item })
              ])
            ], 2))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})